import { useWorkflowName } from '../useWorkflowName';

export function useWorkflowNameOrFail(): string {
  const workflowName = useWorkflowName();

  if (!workflowName) {
    throw new Error('Cannot return workflow name: workflow name is missing.');
  }

  return workflowName;
}
